// @Core
import { sessionUtils } from '@openbank/cf-ui-architecture-core';
// Types
import {
  SuccessBuilderHandlersType,
  SuccessMethodsHandlersType,
} from './types/success.handlers.type';
// Utilities
import { navigateToCallbackUrl } from 'utils/app-callback-url.utils';

const redirectSuccessToAmazonButtonClickHandler = ({
  callbackUrl,
  loanId,
}: SuccessBuilderHandlersType): void => {
  sessionUtils.clearSessionData();
  navigateToCallbackUrl({ callbackUrl, loanId });
};

const SuccessHandlers = (props: SuccessBuilderHandlersType): SuccessMethodsHandlersType => ({
  handleRedirectSuccessToAmazonButtonClick: () => redirectSuccessToAmazonButtonClickHandler(props),
});

export { SuccessHandlers };
